(function () {
  function resolveTarget(targetId) {
    if (!targetId) return null;

    let el = document.getElementById(targetId);
    if (el) return el;

    el = document.querySelector(`[id$="__${targetId}"]`);
    if (el) return el;

    el = document.querySelector(`[id$="${targetId}"]`);
    if (el) return el;

    return null;
  }

  function resolveTitle(targetId) {
    const root = resolveTarget(targetId);
    if (!root) return null;

    if (root.matches('.quiz-panel__title, .sellingpoints-title, .gift-card__title, h2, h3')) {
      return root;
    }

    const quizTitle = root.querySelector('.quiz-panel__title');
    if (quizTitle) return quizTitle;

    if (root.classList.contains('sellingpoints-title')) return root;

    const giftTitle = root.querySelector('.gift-card__title');
    if (giftTitle) return giftTitle;

    return root;
  }

  function resolveSectionRoot(targetId) {
    const el = resolveTarget(targetId);
    if (!el) return null;

    if (targetId.endsWith('_intro')) {
      return el;
    }

    const shopifySection = el.closest('.shopify-section');
    if (shopifySection) return shopifySection;

    return el;
  }

  function getElementTop(el) {
    return el.getBoundingClientRect().top + window.pageYOffset;
  }

  document.addEventListener('DOMContentLoaded', () => {
    const nav = document.getElementById('spring-sale-pre-nav');
    if (!nav) return;

    const navItems = nav.querySelectorAll('.nav-wrapper .nav');
    const header = document.querySelector('.site-header');
    const baseOffset = 8;
    const sections = [];
    let scrollLockUntil = 0;
    let scrollEndTimer = null;

    let headerHeight = header ? header.offsetHeight : 0;
    let navTop = nav.offsetTop;
    let triggerPoint = navTop - headerHeight;

    function getViewportMarker() {
      const isFixed = nav.classList.contains('fixed');
      const navHeight = isFixed ? nav.offsetHeight : 0;
      const hHeight = isFixed ? 0 : header ? header.offsetHeight : 0;
      return hHeight + navHeight + baseOffset;
    }

    function getScrollOffset() {
      return getViewportMarker();
    }

    function scrollSectionIntoView(sectionEl) {
      const marker = getScrollOffset();
      const availableHeight = window.innerHeight - marker;
      const sectionTop = getElementTop(sectionEl);
      const sectionHeight = sectionEl.getBoundingClientRect().height;
      const maxScroll = document.documentElement.scrollHeight - window.innerHeight;

      let targetScroll;

      if (sectionHeight <= availableHeight) {
        targetScroll = sectionTop - marker - (availableHeight - sectionHeight) / 2;
      } else {
        targetScroll = sectionTop - marker;
      }

      targetScroll = Math.max(0, Math.min(targetScroll, maxScroll));

      window.scrollTo({
        top: targetScroll,
        behavior: 'smooth',
      });
    }

    function recalcOffsets() {
      headerHeight = header ? header.offsetHeight : 0;

      const wasFixed = nav.classList.contains('fixed');
      if (wasFixed) {
        nav.classList.remove('fixed');
        nav.style.top = '';
      }

      navTop = nav.offsetTop;
      triggerPoint = navTop - headerHeight;

      if (wasFixed && window.scrollY > triggerPoint) {
        nav.classList.add('fixed');
        nav.style.top = '0px';
      }
    }

    function setActiveNav(targetId) {
      navItems.forEach((item) => {
        item.classList.toggle('active', item.getAttribute('data-section') === targetId);
      });
    }

    function updateActiveNav() {
      if (Date.now() < scrollLockUntil) return;

      const marker = getViewportMarker();
      let currentId = sections[0]?.id || '';
      let closestDistance = Infinity;

      sections.forEach((section) => {
        const rect = section.titleEl.getBoundingClientRect();
        const isInViewport = rect.bottom > marker && rect.top < window.innerHeight;

        if (!isInViewport) return;

        const distance = Math.abs(rect.top - marker);
        if (distance < closestDistance) {
          closestDistance = distance;
          currentId = section.id;
        }
      });

      if (closestDistance === Infinity && sections.length > 0) {
        const scrollY = window.scrollY + marker;

        for (let i = sections.length - 1; i >= 0; i--) {
          const sectionTop = getElementTop(sections[i].titleEl);
          if (scrollY >= sectionTop) {
            currentId = sections[i].id;
            break;
          }
        }
      }

      setActiveNav(currentId);
    }

    function lockScrollSpy(durationMs) {
      scrollLockUntil = Date.now() + durationMs;
    }

    function onScrollEnd() {
      scrollLockUntil = 0;
      updateActiveNav();
    }

    function onScroll() {
      if (window.scrollY > triggerPoint) {
        nav.classList.add('fixed');
        if (header) header.style.display = 'none';
        nav.style.top = '0px';
      } else {
        nav.classList.remove('fixed');
        nav.style.top = '';
        if (header) header.style.display = '';
      }

      clearTimeout(scrollEndTimer);
      scrollEndTimer = setTimeout(onScrollEnd, 120);

      updateActiveNav();
    }

    recalcOffsets();
    window.addEventListener('resize', () => {
      recalcOffsets();
      updateActiveNav();
    });

    navItems.forEach((item) => {
      const targetId = item.getAttribute('data-section');
      const titleEl = resolveTitle(targetId);
      if (titleEl) {
        sections.push({ id: targetId, titleEl });
      }
    });

    navItems.forEach((item) => {
      item.addEventListener('click', (e) => {
        e.preventDefault();

        let targetId = item.getAttribute('data-section');

        if (targetId === 'hot-sale') {
          targetId = window.innerWidth < 768 ? 'hot-sale-nav' : 'hot-sale';
        }

        const sectionRoot = resolveSectionRoot(targetId);

        if (sectionRoot) {
          lockScrollSpy(800);
          setActiveNav(targetId);
          scrollSectionIntoView(sectionRoot);

          if (window.dataLayer) {
            window.dataLayer.push({ event_parameters: null });
            window.dataLayer.push({
              event: 'ga4Event',
              event_name: 'select_content_category',
              event_parameters: {
                button_name: item.textContent?.trim(),
                content_type: 'navbar',
              },
            });
          }
        }
      });
    });

    window.addEventListener('scroll', onScroll, { passive: true });
    updateActiveNav();
  });
})();
